import React, { useEffect } from 'react';
import { FaLocationArrow } from 'react-icons/fa';
import { BsFillBookmarkStarFill } from 'react-icons/bs';
import { MdReviews } from 'react-icons/md';
import './TopGuides.scss';
import { Link } from 'react-router-dom';

const TopGuides = () => {

    useEffect(() => {
        const script = document.createElement("script");
        script.innerHTML = `
        var swiper = new Swiper(".blog-slider", {
          spaceBetween: 30,
          effect: "fade",
          loop: true,
          mousewheel: {
            invert: false,
          },
          pagination: {
            el: ".blog-slider__pagination",
            clickable: true,
          },
        })`;
        document.body.appendChild(script);
    }, []);

    return (
        <div className="blog-slider">
            <div className="blog-slider__wrp swiper-wrapper">
                <div className="blog-slider__item swiper-slide">
                    <div className="blog-slider__img">
                        <img src='https://i.ibb.co/PxXKbkW/guide.jpg' lt="guide" />
                    </div>
                    <div className="blog-slider__content">
                        <span className="blog-slider__code">
                            <div className='flex items-center justify-center md:justify-start'>
                                <FaLocationArrow />
                                <p className='pl-2 font-semibold'>Rajshahi, Bangladesh</p>
                            </div>
                        </span>
                        <div className="blog-slider__title text-4xl mb-0">Francisco José</div>
                        <div className='flex items-center justify-center md:justify-start mt-2 mb-4'>
                            <BsFillBookmarkStarFill className='text-yellow-500' />
                            <p className='font-semibold px-1'>4.89</p>
                            <MdReviews className='ml-8 text-yellow-500' />
                            <p className='font-medium px-1'>612+ reviews</p>
                        </div>
                        <div className="blog-slider__text">
                            <small>
                                Hi! I'm Francisco :) I´m a local guide, born and raised in sintra. I heard many legends about mysticism, secrets and sintra stories. Later I joined a group in sintra and deepened my historical knowledge and the Portuguese spiritual tradition linked to the Templars and Cathars.
                            </small>
                        </div>
                        <Link to='/' className="blog-slider__button">
                            View Profile
                        </Link>
                    </div>
                </div>
                <div className="blog-slider__item swiper-slide">
                    <div className="blog-slider__img">
                        <img src='https://i.ibb.co/t3j1mSR/g7.jpg' lt="guide" />
                    </div>
                    <div className="blog-slider__content">
                        <span className="blog-slider__code">
                            <div className='flex items-center justify-center md:justify-start'>
                                <FaLocationArrow />
                                <p className='pl-2 font-semibold'>Khulna, Bangladesh</p>
                            </div>
                        </span>
                        <div className="blog-slider__title text-4xl mb-0">Melipe Jordan</div>
                        <div className='flex items-center justify-center md:justify-start mt-2 mb-4'>
                            <BsFillBookmarkStarFill className='text-yellow-500' />
                            <p className='font-semibold px-1'>4.76</p>
                            <MdReviews className='ml-8 text-yellow-500' />
                            <p className='font-medium px-1'>527+ reviews</p>
                        </div>
                        <div className="blog-slider__text">
                            <small>
                                Carioca from the yolk, the delight of Benfica. Captain of the best pubcrawl in Rio de Janeiro and founder of one of the most ambitious tourism companies in the city. I have samba in the foot, and better in dancing. And besides, I know everyone in the city, and the city is pretty big haha.
                            </small>
                        </div>
                        <Link to='/' className="blog-slider__button">
                            View Profile
                        </Link>
                    </div>
                </div>
                <div className="blog-slider__item swiper-slide">
                    <div className="blog-slider__img">
                        <img src='https://i.ibb.co/zx3YmHy/g8.jpg' lt="guide" />
                    </div>
                    <div className="blog-slider__content">
                        <span className="blog-slider__code">
                            <div className='flex items-center justify-center md:justify-start'>
                                <FaLocationArrow />
                                <p className='pl-2 font-semibold'>Adolfo Henger</p>
                            </div>
                        </span>
                        <div className="blog-slider__title text-4xl mb-0">Francisco José</div>
                        <div className='flex items-center justify-center md:justify-start mt-2 mb-4'>
                            <BsFillBookmarkStarFill className='text-yellow-500' />
                            <p className='font-semibold px-1'>4.73</p>
                            <MdReviews className='ml-8 text-yellow-500' />
                            <p className='font-medium px-1'>552+ reviews</p>
                        </div>
                        <div className="blog-slider__text">
                            <small>
                                For a graduate of Tourism with a degree in Art History, there is surely no better place to establish a career as a Tour Guide than in the marvelous city of Toledo.My vast work experience has taken me through the diverse sectors of the world of tourism and art.
                            </small>
                        </div>
                        <Link to='/' className="blog-slider__button">
                            View Profile
                        </Link>
                    </div>
                </div>
            </div>
            <div className="blog-slider__pagination"></div>
        </div>

    );
};

export default TopGuides;